import * as React from "react"

type ShortcutConfig = {
  readonly onNext: () => void
  readonly onPrevious: () => void
  readonly onArchive: () => void
  readonly onSnooze: () => void
  readonly onRegenerate: () => void
  readonly onSend: () => void
  readonly onFocusSearch: () => void
}

export function useKeyboardShortcuts(config: ShortcutConfig) {
  React.useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      const target = event.target
      if (target instanceof HTMLElement) {
        const tag = target.tagName.toLowerCase()
        if (target.isContentEditable || ["input", "textarea", "select"].includes(tag)) return
      }

      if ((event.metaKey || event.ctrlKey) && event.key === "Enter") {
        event.preventDefault()
        config.onSend()
        return
      }

      if (event.metaKey || event.ctrlKey || event.altKey) return

      switch (event.key) {
        case "j":
          event.preventDefault()
          config.onNext()
          break
        case "k":
          event.preventDefault()
          config.onPrevious()
          break
        case "e":
          event.preventDefault()
          config.onArchive()
          break
        case "s":
          event.preventDefault()
          config.onSnooze()
          break
        case "r":
          event.preventDefault()
          config.onRegenerate()
          break
        case "/":
          event.preventDefault()
          config.onFocusSearch()
          break
        default:
          break
      }
    }

    window.addEventListener("keydown", onKeyDown)
    return () => window.removeEventListener("keydown", onKeyDown)
  }, [config])
}
